import React, { Component } from "react";
import { Textbox, Textarea } from 'react-inputs-validation';
import 'react-inputs-validation/lib/react-inputs-validation.min.css';
import $ from "jquery";
import { LOGIN_TYPE_ADMIN, LEAD_GENERATION_API, REPORT_GENERATION_API, REPORT_DATA_LIMIT,CLIENT_LIST,DOWNLOAD_CSV_REPORT,unlink_file,SERVICE40_TEXT } from './helper/Constants'
import { Alert, DateRangePicker } from 'rsuite';
import 'rsuite/dist/styles/rsuite-default.css'
import Apihelpers from "./helper/ApiHelper";
import { NavLink } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import UnAuthorised from "./UnAuthorised";
import Select2 from 'react-select2-wrapper';
import moment from 'moment';
import Header from "./include/Header";

const FileDownload = require('js-file-download');


class Leadreport extends Component {

  constructor(props) {
    super(props);
    this.state = {
      reportType: 'lead',
      reportDate: '',
      reportData: [],
      clientList:[],
      selectedClient:'',
      selectedClientUserName:'',
      ToBeFileSaveName:'',
      IsDownLoadTrue:false,
      IsGenrateTrue:false,
      FileNames:[],
      backDate:'',
      startrange:'',
      endrange:'',
      apiType:'all',
      sourceType: 'all',
      responseType: 'basicDetail'
    };
  }

  componentDidMount() {
    let d = new Date();
    let today = new Date(d.getFullYear(), d.getMonth(), 2).toISOString().slice(0, 10);
    d.setDate(d.getDate() - 120);
    this.setState({
      startrange: today,
      endrange:new Date().toISOString().slice(0, 10),
      backDate:'2022-01-01'//d.toISOString().slice(0, 10)
    });

    this.loadClientListDetail();
  }

  onchange = (e) => {
    if (e.target.name === 'reportType') {
      this.setState({
        //reportType: e.target.value,
        reportData: [],
        [e.target.name]: e.target.value
      })
    } else {
      this.setState({
        reportDate: e.target.value,
        reportData: [],
        [e.target.name]: e.target.value
      })
    }
  }

  onSubmit = (e) => {
    e.preventDefault();
    let startD = this.state.startrange;
    let endD = this.state.endrange;
    let dayDiff = new Date(endD) - new Date(startD);
    dayDiff = dayDiff / (1000 * 60 * 60 * 24);
    //console.log('dayDiff',dayDiff);
    if (dayDiff > 16 || dayDiff < 0) {
      Alert.error("Please select date range maximum 16 days and minimume 1 day");
      return;
    }
    let parmsobj = {
      reportType: this.state.reportType,
      startrange: this.state.startrange,
      endrange: this.state.endrange,
      selectedClient: this.state.selectedClient,
      apiType: this.state.apiType,
      sourceType: this.state.sourceType,
      responseType: this.state.responseType
    }
    console.log('parmsobj',parmsobj);
    //return;
    if (this.state.reportType === '' || this.state.startrange === '' || this.state.endrange === '') {
      Alert.error("Please select a valid Date Range");
    } else if (this.state.reportType === 'lead') {
      Apihelpers.postdataresponse(LEAD_GENERATION_API, parmsobj).then(res => {
        if (res.data.status === true) {
          const fileName = res.data.data[0].fileName;
          Alert.success("Lead Report Generated Successfully");
          Apihelpers.downloadFileresponse("export-report/" + fileName).then(res => {
            FileDownload(res.data, fileName);
            setTimeout( ()=>{ 
           const detlete_file_path = { "filepath": "/reportgeneratedExcel/" + fileName ,isFullPath:true};
            Apihelpers.postdataresponse(unlink_file, detlete_file_path);
                           
           }, 7000);
          }).catch((err) => {
            console.log(err);
          });
        } else {
          Alert.error("Error While Generating Report");
        }
      });
    } else if (this.state.reportType === 'rctransfer') {
      Apihelpers.postdataresponse('bbuser/generate_rctransfer_report', parmsobj).then(res => {
        if (res.data.status === true) {
          const fileName = res.data.data[0].fileName;
          Alert.success("RC Transfer Report Generated Successfully");
          Apihelpers.downloadFileresponse("export-report/" + fileName).then(res => {
            FileDownload(res.data, fileName);
            setTimeout( ()=>{ 
              const detlete_file_path = { "filepath": "/reportgeneratedExcel/" + fileName ,isFullPath:true};
               Apihelpers.postdataresponse(unlink_file, detlete_file_path);
                              
              }, 7000);
          }).catch((err) => {
            console.log(err);
          });
        } else {
          Alert.error("Error While Generating Report");
        }
      });
    } else {
      let from = moment(this.state.startrange, 'YYYY/M/D');
      var to = moment(this.state.endrange, 'YYYY/M/D');
      var diffDays = to.diff(from, 'days');
      if(this.state.reportType === 'apihit' && diffDays >=16)
      {
        Alert.error("Please select a valid Date Range(Maximum 16 days allowed)");
      }
      else if(this.state.reportType === 'apihit')
      {
        $('.loader').show();
        Apihelpers.postdataresponse(REPORT_GENERATION_API, parmsobj).then(res => {
          if (res.data.status === true ) {
            $('.loader').hide();
            //console.log('apihit res.data',res.data);
            if(res.data.data.length > 0) {
              let count = 0;
              res.data.data.forEach((it)=>{
                count = count+it.count;
              });
              console.log('count',count);
              if(count > 200000) {
                Alert.error("Please reduse date range api hit count should maximum 200000");
                return;
              }
            }
            this.setState({
              reportData: res.data.data
            },()=>{
              if(this.state.reportType === 'apihit' && res.data.message == 'Report Generated Successfully' && this.state.reportData.length >0)
              {
                this.setState({
                  IsGenrateTrue:true,
                  IsDownLoadTrue:false,
                });
              }
              else{
                this.setState({
                  IsDownLoadTrue:false,
                  IsGenrateTrue:false,
                });
              }
            })
          }
        });
      }
      else{
      $('.loader').show();
      Apihelpers.postdataresponse(REPORT_GENERATION_API, parmsobj).then(res => {
        if (res.data.status === true) {
          $('.loader').hide();
          this.setState({
            reportData: res.data.data
          });
        }
      });}
    }
  }
/**
 * Get client list (user of bbuser collection)
 * Start
 */
 loadClientListDetail() {
  var clientListForInternal=[];
  Apihelpers.getdataresponse(CLIENT_LIST+'?search=all').then(res => {
    if (res.data.status === true) {
      var client_list=res.data.data[0]["businessname"];
      var result=client_list.map((values,index)=>{
         clientListForInternal[values.id]= values.text;
        let client_display_name=values.text+" ("+values.id+")";
        return {key:index,id:values.id,text:client_display_name}
      });
      this.setState({
        clientList: [{ 'key': '0000', 'id': '-1', 'text': 'All' }].concat(result),
        selectedClient: -1
      });
      //console.log(this.state.clientList);
    }
  });
}
setSelectedUser(userId)
{
  var clientName = this.state.clientList.find(data => data.id === userId);
  if(userId == -1)
  {
    this.setState({IsGenrateTrue:false,IsDownLoadTrue:false});
  }
  this.setState(
    { selectedClient: userId,
      selectedClientUserName:clientName.text,
      ToBeFileSaveName:clientName.text.replace(' ','_'),
    },()=>{
      
    });
}
/**
 * Get client list (user of bbuser collection)
 * End
 */
GenrateReport = ()=>{
  $('.loader').show();
  let parmsobj = {
    reportType: this.state.reportType,
    startrange: this.state.startrange,
    endrange: this.state.endrange,
    selectedClient: this.state.selectedClient,
    apiType: this.state.apiType,
    sourceType: this.state.sourceType,
    selectedClientUserName: this.state.selectedClientUserName,
    responseType: this.state.responseType
  }
  Apihelpers.postdataresponse(DOWNLOAD_CSV_REPORT, parmsobj).then(res => {
    $('.loader').hide();
    if (res.data.status === true && res.data.message == 'Report Generated Successfully') {
      console.log(res.data.data);
      this.setState({
        FileNames:res.data.data,
        IsDownLoadTrue:true,
        IsGenrateTrue:false,
      });
    } else if (res.data.message === "Please Check Reporlist"){
      this.setState({
        FileNames:[],
        IsDownLoadTrue:false
      });
      window.open('../admin/reportList', '_blank', 'noopener,noreferrer');
    }
  });
}
Download=() =>{
  $('.loader').show();
  if (this.state.FileNames !== undefined) {
    var Total_number_of_files = this.state.FileNames.length;
    this.state.FileNames.map((data,index)=>{
      Apihelpers.downloadFileresponse("export-report/" +data).then(res => {
        FileDownload(res.data,data);
        setTimeout(()=> { 
          const detlete_file_path = { "filepath": "/reportgeneratedExcel/" + data ,isFullPath:true};
          Apihelpers.postdataresponse(unlink_file, detlete_file_path);
          if(index== (Total_number_of_files-1)) {
            this.setState({
              IsDownLoadTrue:false,
              IsGenrateTrue:true,
            });
          }
        }, 7000);
      }).catch((err) => {
        console.log(err);
      });
    });
  } else {
    Alert.error("download not available"); 
  }
  $('.loader').hide();
  if(Total_number_of_files >1) {
    Alert.success("Total "+Total_number_of_files+" files download successfully.(Each File contains 50000 data)"); 
  }
}

  render() {
    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN || reactLocalStorage.get("is_have_raw_report_service") === SERVICE40_TEXT) {
      const {
        beforeToday,
      } = DateRangePicker;

      const renderTitle = () => {
        if (this.state.reportType === 'user') {
          return "User Registration Report";
        } else if (this.state.reportType === 'payment') {
          return "Payment History Report";
        } else if (this.state.reportType === 'apihit') {
          return "API Hits Report";
        } else if (this.state.reportType === 'lead') {
          return "Leads Report";
        }
      }

      const renderTableHeader = () => {
        if (this.state.reportType === 'user') {
          return <React.Fragment><th>Date</th><th>Users Count</th></React.Fragment>;
        } else if (this.state.reportType === 'payment') {
          return <React.Fragment><th>Date Time</th><th>Vehicle Id</th><th>Amount</th></React.Fragment>;
        } else if (this.state.reportType === 'apihit') {
          return <React.Fragment><th>Date</th><th>User Id</th><th>API Type</th><th>Count</th></React.Fragment>;
        } else {
          return <th>N/A</th>;
        }
      }

      return (

        <React.Fragment>
          <div className="wrapper">
            <Header />
            <div className="container">
              <div className="whiteBox reportPage">
                <div className="reportHeading">
                  <div className="titleRow">
                    <div className="row align-items-center">
                      <div className="col">
                        <h3 className="title">Generate Reports </h3>
                      </div>
                      <div className="col-auto">
                        <NavLink to={"/admin/dashboard"} className="backLink"><i className="fa fa-arrow-left"></i> Back</NavLink>
                      </div>
                    </div>
                  </div>
                  <form className="form blockFilter" onSubmit={this.onSubmit} >
                    <div className="row">
                      <div className="col">
                        <div className="form-group">
                          <label className="control-title">Report Type</label>
                          <select className="form-control" onChange={this.onchange} name="reportType">
                            <option value="lead">Leads</option>
                            <option value="user">User</option>
                            <option value="payment">Payment</option>
                            <option value="apihit">ApiHits</option>
                            <option value="rctransfer">Rc Transfer</option>
                          </select>
                        </div>
                      </div>
                     {
                      (this.state.reportType !== 'apihit')?'': <React.Fragment>
                        <div className="col">
                          <div className="form-group" style={{minWidth:"250px"}}>
                            <label className="control-title">Select User</label>
                            <Select2 
                            className="form-control" 
                            data={this.state.clientList}
                            id="userType"
                            value={this.state.selectedClient}
                            name="userType"
                            onChange={(e) => this.setSelectedUser(e.target.value)}  />
                          </div>
                        </div>
                        <div className="col">
                          <div className="form-group">
                            <label className="control-title">API Type</label>
                            <select className="form-control" value={this.state.apiType} onChange={(e)=>this.setState({apiType:e.target.value})}>
                              <option value="all">All</option>
                              <option value="9">RCPrime</option>
                              <option value="10">RCExcel</option>
                              <option value="3">ServiceHistory</option>
                              <option value="2">Challan</option>
                              <option value="36">ChallanExcel</option>
                              <option value="14">UsedCarPricing</option>
                              <option value="0">freeRC</option>
                              <option value="15">RCPrimeReverse</option>
                              <option value="19">UsedCarPricingV2</option>
                              <option value="32">comboPrime</option>
                              <option value="33">comboChallan</option>
                              <option value="21">PanFetch</option>
                              <option value="26">PanExtensive</option>
                              <option value="24">AadhaarExtraction</option>
                              <option value="22">BasicForgery</option>
                              <option value="23">AdvanceForgery</option> 
                              <option value="34">AadhaarFetch</option> 
                              <option value="37">MobileExcel</option>
                              <option value="38">comboMobilePrimeExcel</option>                                                       
                              <option value="38">comboMobilePrimeExcel</option>
                              <option value="42">Aadhaar Okyc Otp</option>
                              <option value="43">Aadhaar Okyc Info</option> 
                              <option value="25">MMV</option>                                                          

                            </select>
                          </div>
                        </div>
                        <div className="col">
                          <div className="form-group">
                            <label className="control-title">Source Type</label>
                            <select className="form-control" value={this.state.sourceType} onChange={(e)=>this.setState({sourceType:e.target.value})}>
                              <option value="all">All</option>
                              <option value="database">Our DB</option>
                              <option value="database_temp">DB Temp</option>
                              <option value="zoop">Alpha</option>
                              <option value="surepass">Beta</option>
                              <option value="gamma">Gamma</option>
                              <option value="delta">Delta</option>
                              <option value="deltav2">DeltaV2</option>
                              <option value="deltaCache">Delta Cache</option>
                              <option value="deltaPro">Delta Pro</option>
                              <option value="theta">Theta</option>
                            </select>
                          </div>
                        </div>
                      </React.Fragment>
                      }
                      <div className="col">
                        <label className="control-title">Select Start Range</label>
                        <div className="form-group">
                          <input type="date" min={this.state.backDate} className="form-control" name="startrange" onChange={this.onchange} value={this.state.startrange} />
                        </div>
                      </div>

                      <div className="col">
                        <label className="control-title">Select End Range</label>
                        <div className="form-group">
                          <input type="date" min={this.state.backDate} className="form-control" name="endrange" onChange={this.onchange} value={this.state.endrange} />
                        </div>
                      </div>
                      <div className="col-auto">
                        <input type="submit" value="Submit" className="blueBtn" />
                      </div>
                    </div>
                  </form>
                </div>
              
                {
                  (this.state.reportType === 'lead' || this.state.reportType === 'rctransfer') ? '' :
                  <div className="reportList">
                    <div className="row">
                      <div className="col">
                        <h3 className="title">{renderTitle()} ({this.state.reportData.length})</h3>
                      </div>
                      {this.state.IsGenrateTrue == false ?' ':
                      
                        <div className="col-auto">
                          <div className="titleWithRightFilter">
                            <div className="row">
                              <div className="col">
                                <select className="form-control" value={this.state.responseType} onChange={(e)=>this.setState({responseType:e.target.value})}>
                                  <option value="basicDetail">Basic Detail</option>
                                  <option value="completeDetail">Complete Detail</option>
                                </select>
                              </div>
                              <div className="col">
                                <input type="submit" title="Reports" activeClassName="active" value="Genrate Report" className="btn-sm yellowBtn"  onClick={this.GenrateReport}/>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      {this.state.IsDownLoadTrue == false ?' ':
                        <div className="col-auto">
                          <input type="submit"  title="Reports" activeClassName="active" value="Download" className="btn-sm yellowBtn"  onClick={this.Download}/>
                        </div>
                      }
                    </div>
                    <div className="tableBorder">
                      <table className="table">
                        <tbody>
                          <tr>
                            {renderTableHeader()}
                          </tr>
                          {
                            this.state.reportData.length > 0
                              ?
                              this.state.reportData.map((data, key) => {
                                return (
                                  this.state.reportType === 'user'
                                    ?
                                    <tr key={key}><td>{data._id}</td><td>{data.count}</td></tr>
                                    :
                                    this.state.reportType === 'payment'
                                      ?
                                      <tr key={key}><td>{data.payment_date}</td><td>{data.vehicle_id}</td><td>{data.amount}</td></tr>
                                      :
                                      this.state.reportType === 'apihit'
                                        ?
                                        <tr key={key}><td>{data._id.date}</td><td>{data._id.user_id}</td><td>{data._id.api_type}</td><td>{data.count}</td></tr>
                                        :
                                        ''
                                );
                              })
                              :
                              <tr>
                                <td colSpan="9" align="center">
                                  <img src="/assets/images/data-not-found-img.png" /><br /><br />
                                  <b>No Data Found</b>
                                </td>
                              </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                    <div className="text-center">*Report data have a maximum limit of {REPORT_DATA_LIMIT} records, please narrow down your search with appropriate date range</div>
                  </div>
                }
              </div>
            </div>
          </div>
          <div className="loader">
            <div className="bg"></div>
            <img className="loadingImg" src="/assets/images/loading.gif" alt="" />
          </div>
        </React.Fragment >
      )
    } else {
      return (
        <UnAuthorised></UnAuthorised>
      )
    }

  }
}

export default Leadreport;
